<template>
  <v-autocomplete
    :value="value"
    :items="skillsList"
    :label="$t('EMPLOYEES.SKILLS')"
    :search-input.sync="search"
    :counter="counter"
    :menu-props="menuProps"
    item-value="id"
    item-text="name"
    multiple
    chips
    small-chips
    deletable-chips
    append-outer-icon="mdi-close"
    v-bind="$attrs"
    v-on="listeners"
  ></v-autocomplete>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import clearableSelectFilter from '../filters/mixins/clearableSelectFilter';

export default {
  name: 'SkillsFilter',

  mixins: [clearableSelectFilter],

  data() {
    return {
      skillsList: []
    };
  },

  mounted() {
    this.getEmployeeSkills().then(({ data }) => {
      this.skillsList = data.data;
    });
  },

  methods: {
    ...mapCacheActions('employee', ['getEmployeeSkills'])
  }
};
</script>

<style scoped></style>
